/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Household_Teen_Confirm_CancelInputs */

const fr_household_teen_confirm_cancel = /** @type {(inputs: Household_Teen_Confirm_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rester inscrit`)
};

/**

* @param {Household_Teen_Confirm_CancelInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const household_teen_confirm_cancel = /** @type {((inputs?: Household_Teen_Confirm_CancelInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Household_Teen_Confirm_CancelInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_household_teen_confirm_cancel(inputs)
});